<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="用户名称">
              <el-select
                v-model="where.user_id"
                multiple
                clearable
                filterable
                allow-create
                class="ele-block"
                placeholder="请选择">
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.username" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="用户订单">
              <el-input clearable v-model="where.merchantOrderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="系统订单">
              <el-input clearable v-model="where.orderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="交易类型">
              <el-select clearable class="ele-block" v-model="where.channel_id" placeholder="请选择">
                <el-option
                  v-for="item in channelList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.channel_name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="收款名称">
              <el-input clearable v-model="where.inPayerName" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="付款名称">
              <el-input clearable v-model="where.payerName" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="10">
            <el-form-item label="交易状态">
              <el-select clearable class="ele-block" v-model="where.order_status" placeholder="请选择">
                <el-option v-for="item in orderStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="10">
            <el-form-item label="账变状态">
              <el-select clearable class="ele-block" v-model="where.is_balance" placeholder="请选择">
                <el-option v-for="item in isBalanceOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="16" :md="24">
            <el-form-item label="选择时间">
              <div class="inlist-time-wrap">
                <el-radio-group v-model="timeQuick" size="small" @change="onTimeQuickChange">
                  <el-radio-button label="today">今日</el-radio-button>
                  <el-radio-button label="yesterday">昨日</el-radio-button>
                  <el-radio-button label="week">本周</el-radio-button>
                  <el-radio-button label="month">本月</el-radio-button>
                  <el-radio-button label="lastMonth">上月</el-radio-button>
                  <el-radio-button label="days30">30日</el-radio-button>
                </el-radio-group>
                <el-date-picker
                  v-model="where.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="onTimePickerChange" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
              <el-button type="danger" icon="el-icon-document" size="small" class="ele-btn-icon" @click="onExportClick">导出</el-button>
              <el-button type="primary" icon="el-icon-refresh" size="small" class="ele-btn-icon" @click="startAutoRefresh">开启</el-button>
              <el-button type="primary" icon="el-icon-refresh" size="small" class="ele-btn-icon" @click="stopAutoRefresh">关闭</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="inlist-stat-bar">
        <span>订单总量: {{ dataList.total_count }}</span>
        <span>成功数量: {{ dataList.success_count }}</span>
        <span>失败数量: {{ dataList.fail_count }}</span>
        <span>订单总金额: {{ dataList.total_amount }}</span>
        <span>成功金额: {{ dataList.success_amount }}</span>
        <span>失败金额: {{ dataList.fail_amount }}</span>
        <span>成功率: {{ dataList.success_rate }}</span>
        <span>手续费: {{ dataList.mch_rate_total }} 元</span>
        <span>订单费率: {{ dataList.mch_fees_total }} 元</span>
      </div>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :page-size="20"
        height="calc(100vh - 330px)"
        class="inlist-table"
        @done="onTableDone">
        <template slot="action" slot-scope="{ row }">
          <div class="inlist-action">
            <el-button
              v-if="Number(row.order_status) === 0 && permission.includes('sys:inlist:edit')"
              size="mini"
              type="primary"
              class="ele-btn-icon"
              @click="openEdit(row)">推送</el-button>
            <el-button
              v-if="Number(row.order_status) === -1 && permission.includes('sys:inlist:edit')"
              size="mini"
              type="warning"
              class="ele-btn-icon"
              @click="confirmForcePush(row)">强推</el-button>
            <el-button
              v-if="Number(row.order_status) === 1 && Number(row.callback_status) === 2 && permission.includes('sys:inlist:edit')"
              size="mini"
              type="primary"
              class="ele-btn-icon"
              @click="confirmResend(row)">重发</el-button>
            <el-button
              v-if="Number(row.order_status) === 1 && Number(row.callback_status) === 1 && permission.includes('sys:inlist:edit')"
              size="mini"
              type="danger"
              class="ele-btn-icon"
              @click="confirmCancel(row)">撤销</el-button>
          </div>
        </template>
        <template slot="userOrderInfo" slot-scope="{ row }">
          <div>
            <div>
              商户订单:
              <span
                v-if="row.merchantOrderNo"
                class="copyable-text"
                title="点击复制完整订单号"
                @click="copyText(row.merchantOrderNo)">{{ formatShortOrderNo(row.merchantOrderNo) }}</span>
            </div>
            <div>
              系统订单:
              <span
                v-if="row.orderNo"
                class="copyable-text"
                title="点击复制完整订单号"
                @click="copyText(row.orderNo)">{{ formatShortOrderNo(row.orderNo) }}</span>
            </div>
          </div>
        </template>
        <template slot="requestExpireInfo" slot-scope="{ row }">
          <div>
            <div>请求时间: {{ row.timeStart }}</div>
            <div>超时时间: {{ formatTime(row.expire_time) }}</div>
          </div>
        </template>
        <template slot="channelPayTypeInfo" slot-scope="{ row }">
          <div>
            <div>通道名称: {{ formatChannelName(row) }}</div>
            <div>通道类型: {{ row.channel_type_name }}</div>
          </div>
        </template>
        <template slot="channelInPayerInfo" slot-scope="{ row }">
          <div>
            <div>
              收款姓名: {{ row.inPayerName }}<template v-if="row.finance_name">(<span
                class="copyable-text"
                title="点击复制"
                @click="copyText(row.finance_name)">{{ row.finance_name }}</span>)</template><template v-if="row.admin_name">(<span
                class="copyable-text"
                title="点击复制"
                @click="copyText(row.admin_name)">{{ row.admin_name }}</span>)</template>
            </div>
            <div>收款账号: {{ formatMaskedAccount(row.inPayerAccount, row.inPayerBankName) }}</div>
          </div>
        </template>
        <template slot="amountInfo" slot-scope="{ row }">
          <div>
            <div>付款名称: {{ row.payerName }}</div>
            <div>交易金额: {{ row.paymentAmount }}</div>
          </div>
        </template>
        <template slot="orderTimeInfo" slot-scope="{ row }">
          <div>
            <div>创建时间: {{ formatTime(row.create_time) }}</div>
            <div>更新时间: {{ formatTime(row.update_time) }}</div>
          </div>
        </template>
        <template slot="orderTradeStatus" slot-scope="{ row }">
          <div>
            <div>
              订单状态:
              <span :style="{ color: Number(row.order_status) === 4 ? '#F56C6C' : '#67C23A' }">
                {{ Number(row.order_status) === 4 ? '异常' : '正常' }}
              </span>
            </div>
            <div>交易状态: <dict-tag dict-code="order_related_status" field="order_status" :value="row.order_status" :show-value="false" text-only /></div>
          </div>
        </template>
      </ele-pro-table>
    </el-card>

    <tuis-edit :data="current" :visible.sync="showEdit" :admin_user_id="admin_user_id" @done="reload" />

    <export-progress-dialog ref="exportDialog" biz="inorder" title="导出收款确认" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getDictData, loadDictOptions } from '@/utils/dict';
import ExportProgressDialog from '@/components/ExportProgressDialog.vue';
import TuisEdit from './tuis-edit.vue';

const EMPTY_STATS = {
  total_count: 0,
  success_count: 0,
  fail_count: 0,
  total_amount: '0',
  success_amount: '0',
  fail_amount: '0',
  success_rate: '0%',
  mch_rate_total: '0',
  mch_fees_total: '0'
};

export default {
  name: 'Inlist',
  components: { TuisEdit, ExportProgressDialog },
  computed: {
    ...mapGetters(['permission']),
    admin_user_id() {
      return this.$store.state.user && this.$store.state.user.user && this.$store.state.user.user.id
        ? this.$store.state.user.user.id
        : null;
    }
  },
  data() {
    return {
      url: '/Inorder/index',
      columns: [
        { columnKey: 'id', prop: 'id', label: '序号', width: 60, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        { columnKey: 'userOrderInfo', label: '商户/系统订单', prop: 'userOrderInfo', showOverflowTooltip: false, minWidth: 200, align: 'left', slot: 'userOrderInfo' },
        { columnKey: 'requestExpireInfo', label: '请求/超时时间', prop: 'requestExpireInfo', showOverflowTooltip: false, minWidth: 220, align: 'left', slot: 'requestExpireInfo' },
        { columnKey: 'channelPayTypeInfo', label: '通道/通道类型', prop: 'channelPayTypeInfo', showOverflowTooltip: false, minWidth: 180, align: 'left', slot: 'channelPayTypeInfo' },
        { columnKey: 'channelInPayerInfo', label: '收款信息', prop: 'channelInPayerInfo', showOverflowTooltip: false, minWidth: 220, align: 'left', slot: 'channelInPayerInfo' },
        { columnKey: 'amountInfo', label: '金额信息', prop: 'amountInfo', showOverflowTooltip: false, minWidth: 120, align: 'left', slot: 'amountInfo' },
        { columnKey: 'orderTimeInfo', label: '创建/更新时间', prop: 'orderTimeInfo', showOverflowTooltip: false, minWidth: 220, align: 'left', slot: 'orderTimeInfo' },
        { columnKey: 'orderTradeStatus', label: '订单/交易状态', prop: 'orderTradeStatus', showOverflowTooltip: false, minWidth: 160, align: 'left', slot: 'orderTradeStatus', fixed: 'right' },
        { columnKey: 'action', label: '操作', width: 100, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: { user_id: [], time: null, channel_source: 1 },
      timeQuick: 'today',
      current: null,
      showEdit: false,
      channelList: [],
      userList: [],
      dataList: { ...EMPTY_STATS },
      intervalId: null,
      orderStatusOptions: [],
      isBalanceOptions: []
    };
  },
  created() {
    this.applyTimeQuick('today', false);
  },
  mounted() {
    getDictData('order_related_status');
    loadDictOptions('in_order_status').then((list) => { this.orderStatusOptions = list; }).catch((e) => { this.$message.error(e.message); });
    loadDictOptions('yes_no').then((list) => { this.isBalanceOptions = list; }).catch((e) => { this.$message.error(e.message); });
    this.loadFilters();
    this.getInorderCount();
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
  methods: {
    buildSearchParams() {
      return {
        ...this.where,
        user_id: Array.isArray(this.where.user_id)
          ? this.where.user_id.join(',')
          : this.where.user_id,
        channel_source: 1
      };
    },
    onTableDone() {
      this.$nextTick(() => {
        if (this.$refs.table && this.$refs.table.doLayout) {
          this.$refs.table.doLayout();
        }
      });
    },
    formatMaskedAccount(account, bankName) {
      if (!account) return '';
      let masked = account;
      if (account.length >= 7) {
        masked = `${account.slice(0, 3)}****${account.slice(-4)}`;
      }
      return bankName ? `${masked}(${bankName})` : masked;
    },
    formatShortOrderNo(orderNo) {
      if (!orderNo) return '';
      const text = String(orderNo);
      return text.length <= 14 ? text : `${text.slice(0, 6)}...${text.slice(-6)}`;
    },
    formatChannelName(row) {
      if (!row) return;
      return row.channel_display_name || row.up_channel_name;
    },
    formatTime(value) {
      return value ? this.$util.toDateString(value) : '';
    },
    copyText(text) {
      if (!text) return;
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-999999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message.success('复制成功');
      } catch (err) {
        this.$message.error('复制失败');
      }
      document.body.removeChild(textarea);
    },
    pad2(n) {
      return n < 10 ? `0${n}` : `${n}`;
    },
    formatDateTime(date) {
      const d = date instanceof Date ? date : new Date(date);
      return `${d.getFullYear()}-${this.pad2(d.getMonth() + 1)}-${this.pad2(d.getDate())} ${this.pad2(d.getHours())}:${this.pad2(d.getMinutes())}:${this.pad2(d.getSeconds())}`;
    },
    getTimeRange(key) {
      const now = new Date();
      const start = new Date(now);
      const end = new Date(now);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 0);

      if (key === 'today') {
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'yesterday') {
        start.setDate(start.getDate() - 1);
        end.setDate(end.getDate() - 1);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'week') {
        const day = start.getDay() || 7;
        start.setDate(start.getDate() - day + 1);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'month') {
        start.setDate(1);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'lastMonth') {
        start.setMonth(start.getMonth() - 1, 1);
        end.setDate(0);
        end.setHours(23, 59, 59, 0);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'days30') {
        start.setDate(start.getDate() - 29);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      return null;
    },
    applyTimeQuick(key, doReload = true) {
      this.timeQuick = key;
      this.where.time = this.getTimeRange(key);
      if (doReload) {
        this.reload();
      }
    },
    onTimeQuickChange(key) {
      this.applyTimeQuick(key, true);
    },
    onTimePickerChange() {
      this.timeQuick = '';
    },
    reload() {
      this.$refs.table.reload({ where: this.buildSearchParams() });
      this.getInorderCount();
    },
    reset() {
      this.where = { user_id: [], time: null, channel_source: 1 };
      this.applyTimeQuick('today', true);
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    confirmForcePush(row) {
      this.$confirm('确定要执行【强推】操作吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.openEdit(row);
      }).catch(() => {});
    },
    confirmCancel(row) {
      this.$confirm('确定要【撤销】该订单吗？此操作不可恢复！', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.cancellOrder(row);
      }).catch(() => {});
    },
    confirmResend(row) {
      this.$confirm('确定要执行【重发】操作吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.callBackOne(row);
      }).catch(() => {});
    },
    callBackOne(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/Inorder/callBackOne', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    cancellOrder(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/Inorder/cancellOrder', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    getInorderCount() {
      this.$http.post('/Inorder/getInorderCount', this.buildSearchParams()).then((res) => {
        if (res.data.code === 0) {
          this.dataList = res.data.data || { ...EMPTY_STATS };
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.$message.error(e.message);
      });
    },
    startAutoRefresh() {
      if (this.intervalId != null) return;
      this.intervalId = setInterval(() => {
        this.reload();
      }, 10000);
    },
    stopAutoRefresh() {
      if (this.intervalId == null) return;
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    loadFilters() {
      Promise.all([
        this.$http.post('/ChannelColumnIn/getchannelList', { channel_source: 1 }),
        this.$http.get('/UserBalancesRecords/getUserList')
      ]).then(([channelRes, userRes]) => {
        if (channelRes.data && channelRes.data.code === 0) {
          this.channelList = channelRes.data.data || [];
        }
        if (userRes.data && userRes.data.code === 0) {
          this.userList = userRes.data.data || [];
        }
      }).catch(() => {});
    },
    onExportClick() {
      this.$refs.exportDialog.start(this.buildSearchParams());
    }
  }
};
</script>

<style scoped>
.inlist-stat-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 28px;
  margin-bottom: 12px;
  padding: 10px 16px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.inlist-table ::v-deep .el-table td {
  padding-top: 8px;
  padding-bottom: 8px;
}

.inlist-table ::v-deep .el-table td > .cell {
  white-space: normal;
  line-height: 1.55;
}

.inlist-action {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  gap: 6px;
}

.inlist-action .el-button + .el-button {
  margin-left: 0;
}

.copyable-text {
  color: #409eff;
  cursor: pointer;
}

.copyable-text:hover {
  color: #66b1ff;
}

.inlist-time-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
</style>
